<template>
    <section v-if="hasPermissions(['Associate-Contact-Type Read','Associate-Contact-Type Write', 'Associate-Contact-Type Contact-Type-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Contact Types Typically it is things like Full Time, Part Time, Contract, etc. But you can create any thing you like by clicking "Add Contact Type".
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="contract_types.length && hasPermissions(['Associate-Contact-Type Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'contact_type_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Associate-Contact-Type Contact-Type-Upload'])"
                />
                <button v-if="hasPermissions(['Associate-Contact-Type Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Associate-Contact-Type Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="contract_types.length && hasPermissions(['Associate-Contact-Type Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="contract_types"
                                :search="search"
                                :checkable="true"
                                :link="child_href"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                @emitToParent="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Contact Type'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Contact Type Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'contract_types_types_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import HelperModal          from    '@/components/HelperModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name:   'ContractType',

    components:{
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return{
            notyf,
            axios,
            child_href:             '/associate-contract-types/',
            user:                   this.get_user(),
            title_page:             'Contact Types',
            rest_api:               `contract-types`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Contact Type',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           '',
            single_object:          {},
            contract_types:         [],
            array_options:          {},
            select_ids:             [],
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            summary:                [],
            excel_data:             [],
            helps:                  Resources.helps
        }
    },

    methods:{

        format_boolean(value)
        {
            var boolean_string = ''
            value ? boolean_string = 'Yes' : boolean_string = 'No'
            return boolean_string
        },
        
        unshift_object(new_object)
        {
            this.contract_types.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.contract_types.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.contract_types[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.contract_types[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.contract_types = data.contract_types
        },

        trashing(index)
        {
            this.contract_types.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.contract_types.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.contract_types.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.contract_types.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = [];
            this.excel_data = []

            for ( const value of data ) {
                const entity = {}

                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})
                
                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { contract_types: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                for (const contract_type of response.data.contract_types) {
                    this.unshift_object(contract_type);
                }
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        },


    },

    async mounted()
    {
        if(this.hasPermissions(['Associate-Contact-Type Read']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.contract_types.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>